import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { animate, query, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-pages-layout',
  templateUrl: './pages-layout.component.html',
  animations: [
    trigger('architectUIAnimation', [
      transition('* <=> *', [
        query(':enter, :leave', [
          style({
            opacity: 0,
            display: 'flex',
            flex: '1',
            flexDirection: 'column'
          }),
        ], { optional: true }),
        query(':enter', [
          animate('200ms ease', style({ opacity: 1 })),
        ], { optional: true }),
        query(':leave', [
          animate('200ms ease', style({ opacity: 0 })),
        ], { optional: true })
      ]),
    ])
  ]
})
export class PagesLayoutComponent implements OnInit, AfterViewInit {
  animationState: any = '';

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnInit() {}

  ngAfterViewInit() {
    // Delay to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      const outlet = document.querySelector('router-outlet') as any;
      this.animationState = outlet?.activatedRoute || '';
      this.cdRef.detectChanges();
    });
  }
}
